import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

export default class ConfirmationModal extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    extraClass: PropTypes.string,
  }

  static defaultProps = {
    submitText: 'Yes',
    extraClass: null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
    };

    this.present = this.present.bind(this);
    this.dismiss = this.dismiss.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  present() {
    this.setState({ show: true });
  }

  dismiss() {
    this.setState({ show: false });
  }

  confirm() {
    this.props.onConfirm();
    this.dismiss();
  }

  render() {
    return (
      <Modal
        className={this.props.extraClass}
        centered="true"
        dialogAs="article"
        show={this.state.show}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title as="h4">{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body as="section">{this.props.message}</Modal.Body>
        <Modal.Footer as="footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.dismiss}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.confirm}
          >
            {this.props.submitText}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
